import { render } from "./Services.vue?vue&type=template&id=61eabd47"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"
script.render = render

export default script